import { Carousel, Flex, Select } from "antd";
import BackgroundImage from "../../assets/images/loginPage/background.png";

import { CarouselRef } from "antd/es/carousel";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGE_OPTIONS, Locales } from "../../i18n";
import { LOGIN_PAGE_CARDS } from "../../modules/auth/auth.constants";
import { setLanguageHeader } from "../../utils/axios";
import storage from "../../utils/storage";
import LoginButton from "./components/LoginButton/LoginButton";
import LoginCard from "./components/LoginCard/LoginCard";
import AkcizniProizvodi from "./components/Slides/AkcizniProizvodi";
import InformacijeOSistemu from "./components/Slides/InformacijeOSistemu";
import Propisi from "./components/Slides/Propisi";
import style from "./LoginPage.module.scss";

const SELECT_ITEM_STYLE = {
  backgroundColor: "transparent",
  color: "#69C0FF",
};

const LoginPage = () => {
  const { t, i18n } = useTranslation();
  const carouselRef = useRef<CarouselRef | null>(null);

  const onLanguageChangeHandler = (value: string) => {
    i18n.changeLanguage(value);
    setLanguageHeader(value as Locales);
    storage.setItem("locale", value);
  };

  useEffect(() => {
    // Ant Design has to be overriden this way because of the "portal" for dropdown menu
    const style = document.createElement("style");

    style.textContent = `
      .ant-select-item.ant-select-item-option.ant-select-item-option {
        background-color: transparent !important;
        color: #69c0ff;
      }
    `;

    document.head.appendChild(style);

    return () => {
      // Class has to be removed afterwards to it doesn't affect other select inputs
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Carousel
      ref={carouselRef}
      className={style.background}
      style={{
        backgroundImage: `url(${BackgroundImage})`,
      }}
      dots={false}
      effect="fade"
      adaptiveHeight
    >
      <Flex vertical>
        <Flex justify="end">
          <Select
            onChange={onLanguageChangeHandler}
            options={LANGUAGE_OPTIONS}
            value={storage.getItem("locale") || Locales.LATIN}
            className={style.languageSelect}
            style={SELECT_ITEM_STYLE}
            dropdownStyle={SELECT_ITEM_STYLE}
            bordered={false}
          />
        </Flex>
        <Flex flex={1} gap={103} align="center" justify="center" vertical>
          <Flex justify="center" align="center" gap={42} vertical>
            <Flex align="center" gap={8} vertical>
              <span className={style.title}>{t("LOGIN.EAKCIZE")}</span>
              <span className={style.subtitle}>
                {t("LOGIN.SERVIS_ZA_AKCIZNU_ROBU")}
              </span>
            </Flex>
            <LoginButton />
          </Flex>
          <Flex gap={24} justify="center" className={style.cardWrapper}>
            {LOGIN_PAGE_CARDS.map((card) => {
              return (
                <LoginCard
                  cardInfo={card}
                  key={card?.key}
                  onClick={(slideNumber: number) =>
                    (carouselRef?.current as any)?.goTo?.(slideNumber)
                  }
                />
              );
            })}
          </Flex>
        </Flex>
      </Flex>
      <InformacijeOSistemu
        goBackHandler={() => carouselRef?.current?.goTo?.(0)}
      />
      <AkcizniProizvodi goBackHandler={() => carouselRef?.current?.goTo?.(0)} />
      <Propisi goBackHandler={() => carouselRef?.current?.goTo?.(0)} />
    </Carousel>
  );
};

export default LoginPage;
